module.exports = __webpack_public_path__ + "img/tarya-header.88d71665.svg";